/*
 * @Date: 2020-08-28 11:48:43
 * @Author: MX
 * @LastEditTime: 2024-01-17 14:08:52
 * @Description: http请求封装
 */
import axios from 'axios'
import router from '@/router/index'
import store from '@/store'

// 创建axios实例
const service = axios.create()
// 设置请求的基础路径
service.defaults.baseURL = process.env.VUE_APP_API_URL
console.log(process.env.VUE_APP_API_URL)
// 超时时间
service.defaults.timeout = 15000
// request拦截器
service.interceptors.request.use(config => {
  // 获取vuex的token
  const { token = '' } = store.getters
  config.data = config.data || {}

  // 获取当前路由名称
  const routeName = router.history.current.name
  // 设置请求头authToken
  config.headers.authToken = token
  // 设置请求头routeName
  config.headers.routeName = routeName
  // 设置请求头routeName
  config.headers.deviceId = JSON.parse(localStorage.getItem('deviceInfo') || {}).visitorId
  //  设置了缓存，如果请求参数没变又要实时返回，请在请求后面加时间戳
  config.headers['Cache-Control'] = 'max-age=2, must-revalidate'
  console.log("🚀 ~ config:", config)
  return config
}), error => {
  return Promise.reject(error)
}

// respone拦截器
service.interceptors.response.use((response) => {
  if (response.status === 200) {
    var res = response.data
    //149010008
    if (response.data.code === 149010008) {
      store.dispatch('LOGIN_OUT').then(() => {
        router.push({ name: 'Login' })
        // self.$message.error('没有访问权限，请重新登录')
      })
    }
    return res
  }
}), error => {
  return Promise.reject(error)
}
export const get = (url, params) => service.get(url, { params })
export const post = service.post
export const put = service.put
export const del = service.delete

export default service